<template>
  <el-table-column
    v-bind="$attrs"
    :label="label"
    header-align="center"
  >
    <template slot-scope="scope">
      <el-row
        v-for="(d, idx) in list"
        :key="idx"
        :gutter="6"
        >
        <el-col :sm="12" class="right">
          {{ getListLabel(d.base || base, d.name) }}
        </el-col>
        <el-col :sm="10" class="right">
          {{ getAmount(d, scope.row) }}
        </el-col>
      </el-row>
    </template>
  </el-table-column>
</template>

<script>

import { addCommas } from '@/utils/number'
import { getLabelText } from '@/utils/i18n'

export default {
  name: 'amount-field',
  props: {
    base: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    labelText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
    label () {
      return this.labelText || this.getLabelText('orders', 'amount')
    }
  },
  methods: {
    addCommas,
    getLabelText,
    getListLabel (base, name) {
      const lb = 'api.' + base + '.fields.' + name + '.listLabel'
      if (this.$te(lb)) {
        return this.$t(lb)
      }
      return this.getLabelText(base, name)
    },
    getAmount (d, row) {
      let suffix = d.suffix || ''
      if (typeof d.getAmount === 'function') {
        return d.getAmount(row) + suffix || '-'
      }
      let n = d.dataName || d.name
      return addCommas(row[n]) + suffix
    }
  },
  watch: {
  }
}
</script>
